import React from 'react';
import styles from './LinkWithIcon.module.scss';

function LinkWithIcon({title, icon}) {
  return (
    <span className={styles.link}>
      {title}
      {icon}
    </span>
  );
}

export default LinkWithIcon;
